
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 py-16">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img src="https://placehold.co/200x80?text=JobsDriver" alt="JobsDriver Logo" className="h-12 w-auto" />
            </Link>
            <p className="text-gray-300 mb-6 leading-relaxed">
              JobsDriver is your ultimate job directory for finding career opportunities in Dubai and across the UAE. We connect job seekers with top employers to help you find your dream job.
            </p>
            <div className="flex items-center space-x-4">
              <a href="https://facebook.com/jobsdriver" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 bg-gray-800 hover:bg-primary-600 rounded-full flex items-center justify-center transition-all duration-200 transform hover:scale-110">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com/jobsdriver" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="w-10 h-10 bg-gray-800 hover:bg-primary-600 rounded-full flex items-center justify-center transition-all duration-200 transform hover:scale-110">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://linkedin.com/company/jobsdriver" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-10 h-10 bg-gray-800 hover:bg-primary-600 rounded-full flex items-center justify-center transition-all duration-200 transform hover:scale-110">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://instagram.com/jobsdriver" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 bg-gray-800 hover:bg-primary-600 rounded-full flex items-center justify-center transition-all duration-200 transform hover:scale-110">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">For Job Seekers</h3>
            <div className="space-y-3">
              <Link to="/jobs" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">Browse Jobs</Link>
              <Link to="/categories" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">Job Categories</Link>
              <Link to="/organizations" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">Companies</Link>
              <Link to="/about" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">About Us</Link>
              <Link to="/contact" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">Contact</Link>
              <Link to="/government" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">Government Jobs</Link>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">For Employers</h3>
            <div className="space-y-3">

              <Link to="/about" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">About Us</Link>
              <Link to="/contact" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">Contact Us</Link>
              <Link to="/categories" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">Job Categories</Link>
              <Link to="/employer-login" className="block text-gray-300 hover:text-primary-400 transition-colors duration-200">Employer Login</Link>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Contact Us</h3>
            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3">
                <i className="fas fa-map-marker-alt text-primary-500 mt-1"></i>
                <span className="text-gray-300">Dubai, United Arab Emirates</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="fas fa-phone text-primary-500"></i>
                <a href="tel:+97144001234" className="text-gray-300 hover:text-primary-400 transition-colors duration-200">+971 4 400 1234</a>
              </div>
              <div className="flex items-center space-x-3">
                <i className="fas fa-envelope text-primary-500"></i>
                <a href="mailto:info@jobsdriver.xyz" className="text-gray-300 hover:text-primary-400 transition-colors duration-200">info@jobsdriver.xyz</a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Subscribe to our Newsletter</h4>
              <form className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  placeholder="Your email address"
                  required
                  className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all duration-200"
                />
                <button
                  type="submit"
                  className="px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all duration-200 transform hover:scale-105"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="text-gray-400 mb-4 md:mb-0">
              <p>&copy; 2023 JobsDriver | All Rights Reserved</p>
            </div>
            <div className="flex items-center space-x-6">
              <Link to="/about" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">About Us</Link>
              <Link to="/contact" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">Contact</Link>
              <Link to="/" className="text-gray-400 hover:text-primary-400 transition-colors duration-200">Home</Link>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={scrollToTop}
        className={`${isVisible ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible translate-y-4'} fixed bottom-8 right-8 w-12 h-12 bg-primary-600 hover:bg-primary-700 text-white rounded-full flex items-center justify-center shadow-lg transition-all duration-300 transform hover:scale-110`}
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    </footer>
  );
};

export default Footer;
